
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'

const pad = n => String(String(n).length < 2 ? '0' + n : n)

const asTime = (d: number) => {
  const h = Math.floor(d / 3600)
  const m = Math.floor((d % 3600) / 60)
  const s = Math.floor((d % 3600) % 60)

  return `${h !== 0 ? pad(h) + ':' : ''}${pad(m)}:${pad(s)}`
}

export default Vue.extend({
  data() {
    return {
      message: this.$store.state.project.min_view_message,
      return_url: this.$store.state.return_url,
    }
  },

  computed: {
    ...mapState({
      timer: ({ timer }) => timer,
      button_text: ({ timer }) => {
        if (timer.state === 'running') {
          return `${asTime(timer.remaining_seconds)} remaining`
        } else if (timer.state === 'finished') {
          return 'Return to Survey'
        }
      },
    }),
  },

  methods: {
    ...mapActions(['handle_timer_button_click']),
  },
})
